import { t } from '@lingui/core/macro';
import { Box } from '@pocketlaw/tetris';
import { Select } from 'shared/domains/forms';
import { supportedMarkets, globalMarket } from 'shared/domains/markets/config';
export function MarketField() {
    const label = t({
        message: 'Main market',
        comment: 'signup market select label',
    });
    const placeholder = t({
        message: 'Select market',
        comment: 'signup market select placeholder',
    });
    const allMarketsWithGlobal = [...supportedMarkets, globalMarket];
    return (<Box flexDirection="column" gap="sm">
      <Select label={label} name="marketCode" placeholder={placeholder}>
        {allMarketsWithGlobal.map((market) => (<option key={market.id} value={market.code}>
            {market.getName()}
          </option>))}
      </Select>
    </Box>);
}
